const BooleanCell = (value) => {
  return <>{value === true ? "Y" : "N"}</>;
};

export default BooleanCell;
